export default Object.freeze({
  UNSET: 0,
  ADDITIONAL_INFORMATION: 1,
  CLOSING_ANALYSIS: 2,
  REJECT: 3,
  DOCUMENTS: 4,
  ACCEPT: 5,
});
